import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { useI18n } from '../../utils/i18n';
import apiService from '../../services/apiService';

// #312: Reiter „System-Log“ des Admin-Bereichs, Code unverändert aus
// AdminPanel.js übernommen.
//
// Zustand und Laden stehen im Hook, und den ruft AdminPanel auf, nicht die
// Komponente. So lebt der Zustand so lange wie das Panel: Filter und Seite
// überstehen den Reiterwechsel wie bisher, und geladen wird weiterhin beim
// Klick auf den Reiter. Läge der Zustand in der Komponente, wäre er bei
// jedem Wechsel weg.
export function useLogsTab() {
  // System Log State
  const [logs, setLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);
  const [logFilters, setLogFilters] = useState({ q: '', action: '', ticketNumber: '' });
  const [logPaging, setLogPaging] = useState({ limit: 100, offset: 0 });

  const loadLogs = async () => {
    setLogsLoading(true);
    try {
      const resp = await apiService.getSystemLogs({ ...logFilters, ...logPaging });
      setLogs(resp.logs || []);
    } catch (e) {
      console.error('Error loading logs:', e);
    } finally {
      setLogsLoading(false);
    }
  };

  return { logs, logsLoading, logFilters, setLogFilters, logPaging, setLogPaging, loadLogs };
}

const LogsTab = ({ tab }) => {
  const { getLocale, t } = useI18n();
  const { logs, logsLoading, logFilters, setLogFilters, logPaging, setLogPaging, loadLogs } = tab;

  return (
    <div className="admin-section">
      <h3>System-Log</h3>
      <div className="log-filters" style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12 }}>
        <input
          type="text"
          placeholder="Suchen…"
          value={logFilters.q}
          onChange={(e)=> setLogFilters({ ...logFilters, q: e.target.value })}
          style={{ flex: 1 }}
        />
        <input
          type="text"
          placeholder="Ticketnummer"
          value={logFilters.ticketNumber}
          onChange={(e)=> setLogFilters({ ...logFilters, ticketNumber: e.target.value })}
        />
        <input
          type="text"
          placeholder="Aktion (z.B. ticket_archived)"
          value={logFilters.action}
          onChange={(e)=> setLogFilters({ ...logFilters, action: e.target.value })}
        />
        <button className="btn btn-secondary" onClick={() => { setLogPaging({ ...logPaging, offset: 0 }); loadLogs(); }} disabled={logsLoading}>
          <RefreshCw size={16} /> Laden
        </button>
      </div>
      <div className="logs-table">
        {logsLoading ? (
          <div className="loading"><RefreshCw className="animate-spin" size={24} /> {t('common.loading', 'Lädt…')}</div>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Zeit</th>
                <th>Aktion</th>
                <th>Ticket</th>
                <th>{t('admin.logs.trigger', 'Auslöser')}</th>
                <th>Nachricht</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <tr key={log.id}>
                  <td>{log.createdAt ? new Date(log.createdAt).toLocaleString(getLocale()) : ''}</td>
                  <td><code>{log.action}</code></td>
                  <td>{log.ticketNumber || '-'}</td>
                  <td>{log.triggeredByEmail || log.triggeredByType || '-'}</td>
                  <td>{log.message}</td>
                </tr>
              ))}
              {logs.length === 0 && (
                <tr><td colSpan="5" style={{ textAlign: 'center', color: 'var(--color-text-muted)' }}>{t('admin.logs.empty', 'Keine Einträge')}</td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default LogsTab;
